import { Link } from "react-router-dom";
import type { MockMovie } from "@/mocks/movies";

interface MovieCardProps {
  movie: MockMovie;
  showDescription?: boolean;
}

export default function MovieCard({ movie, showDescription = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors duration-300 animate-fade-up"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 大师兄影视影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-foreground-950/70 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400 text-xs" />
          <span className="text-xs font-semibold text-background-50">{movie.rating.toFixed(1)}</span>
        </div>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded-md bg-primary-500/90 text-[11px] font-medium text-background-50">
          {movie.type}
        </span>
        {showDescription && (
          <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-foreground-950/95 via-foreground-950/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <p className="text-xs leading-5 text-background-100 line-clamp-3">{movie.description}</p>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-600">
          <span className="whitespace-nowrap">{movie.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400" />
          <span className="whitespace-nowrap">{movie.region}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-[11px] text-secondary-900 whitespace-nowrap"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}